import { render, staticRenderFns } from "./AttendanceSettingLayout.vue?vue&type=template&id=740f7440&scoped=true"
import script from "./AttendanceSettingLayout.vue?vue&type=script&lang=js"
export * from "./AttendanceSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f7440",
  null
  
)

export default component.exports